<section id="not-found">
  <div id="title">Pagina no encontrada</div>
  <div class="circles">
    <p>404<br><small> Recurso no encontrado</small></p>
    <span class="circle big"></span>
    <span class="circle med"></span>
    <span class="circle small"></span>
  </div>
</section>
